import styled from "styled-components";
import { AnimationFixed } from "../../../../../components/Animation";

export const ModalBackdrop = styled("div")`
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100%;
  height: calc(100vh * 2);
  background-color: #000;
`;

export const Modal = styled("div")`
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  pointer-events: auto;
`;

export const ModalDialog = styled("div") <{ width: number }>`
  width: 100%;
  padding: 12px 8px;
  max-width: ${(props) => props.width}px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    padding: 0px;
    max-width: ${(props) => props.width}px;
  }
`;

export const ModalContent = styled("div")`
  position: relative;
  display: flex;
  flex-direction: column;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0;
  outline: 0;
  background-color: #fff;
  width: 100%;
  padding: 10px;
  border-radius: 16px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    width: auto;
    padding: 24px 27px;
  }
`;

export const ModalHeader = styled("div")`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const Title = styled("h3")`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin: 24px 0px 20px;
  color: ${(props) => props.theme.colors.Black};
`;

export const Close = styled("button")`
  background: transparent;
  position: absolute;
  cursor: pointer;
  top: 18px;
  right: 18px;
  z-index: 10;
  padding: 0;
  margin: 0;
  border: 0;
  line-height: 1;

  &:focus {
    outline: transparent;
  }
`;

export const ModalBody = styled("div")`
  position: relative;
  line-height: 1.75rem;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    flex: 1 1 auto;
  }
`;

export const ModalFooter = styled("div")`
  padding: 0 0 24px;
  

    display: flex;
    flex-direction: column;
    gap: 8px;
    
    @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
      flex-direction: row;
      justify-content: flex-end;
    }
`;

export const ModalAnimation = styled(AnimationFixed)`
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  pointer-events: auto;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 16px;
  padding: 6px;
  background: #efefef;
  border-radius: 6px;
`;

export const TabButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
            padding: 12px 16px;
            border: none;
            background: transparent;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s ease;
            color: #666;

  &.active {
            background: white;

            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        &:hover:not(.active) {
            color: #333;
            background: rgba(255, 255, 255, 0.5);
        }
`;

export const DummyButton = styled.div`
    font-family: Inter, sans-serif;
    cursor: pointer;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    border: 1px solid #bdbdbd;
    height: 30px;
    background-color: #bcbdbd;
    font-size: 14px;
    color: white;
    border-radius: 6px;
    padding: 0px 17px;
    text-decoration: none;
    letter-spacing: 0.2px;
    font-weight: 500;
    min-width: 150px;
    text-align: center;
    transition: all 0.2s ease;
    opacity: 1;
`;

export const ErrorText = styled.p`
  color: #d32f2f;
  font-size: 13px;
  margin-top: -8px;
  margin-bottom: 8px;
`;

export const DragDropArea = styled.div`
  margin-bottom: 16px;
  padding: 16px;
  text-align: center;
  background-color: #fafafa;
  transition: all 0.2s ease;
  cursor: pointer;
  
  border: 1px dashed #999;
  border-radius: 16px;
  color: #bdbdbd;
  outline: none;

  &.has-file {
    border-color: ${(props) => props.theme.colors.Primary};
    background-color: #f8f9ff;
    border-style: solid;
    color: ${(props) => props.theme.colors.Primary};

    i:before {
      background-color: ${(props) => props.theme.colors.Primary};
    }
  }

  &.has-file:hover {
    background-color: #f0f4ff;
    border-color: ${(props) => props.theme.colors.Primary};

    i:before {
      background-color: ${(props) => props.theme.colors.Primary};
    }
  }

  i:before {
    transition: all 0.2s ease;
  }

  &:hover {
    background-color: #f0f0f0;
    border-color: ${(props) => props.theme.colors.Primary};
    color: ${(props) => props.theme.colors.Primary};

    i:before {
      background-color: ${(props) => props.theme.colors.Primary};
    }

    ${DummyButton} {
      background-color: ${(props) => props.theme.colors.Primary};
      border: 1px solid ${(props) => props.theme.colors.Primary};
      color: #fff;
    }
  }

  &:active {
    background-color: #e8e8e8;
    border-color: ${(props) => props.theme.colors.Primary};
    color: ${(props) => props.theme.colors.Primary};

    i:before {
      background-color: ${(props) => props.theme.colors.Primary};
    }
  }
`;

export const DragDropLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const DragDropText = styled.p`
  font-size: 13px;
  color: #555;
  margin-top: -8px;
  margin-bottom: 16px;
`;
